/*@flow*/
import gql from "graphql-tag";
import type { DocumentNode } from "graphql";

export const GetRecordContacts = (gql(`
  query getRecordContacts($companyId: ID!, $q: String, $first: Int) {
    company(id: $companyId) {
      id
      contacts(q: $q, first: $first) {
        id
        name
      }
    }
  }
`): DocumentNode);
